import React from 'react';
import { Ellipsis, Icon } from '../../../../common';
import './style/index.less';
export default function ({ config, instance }) {
    const { nodeStyle, nodeClassName, statusIcon } = instance;
    const { icon, label, highlight } = config;
    const { width, height } = config;
    return (React.createElement("div", { className: `oflow-client--rectangle-node   
    ${highlight ? 'oflow-client--rectangle-node--highlight' : ''}  
    ${nodeClassName ? nodeClassName : ''}`, style: { width, height } },
        React.createElement("div", { className: "oflow-client--rectangle-node--content", style: nodeStyle },
            icon ? (React.createElement("div", { className: "oflow-client--rectangle-node--icon", style: {
                    background: instance === null || instance === void 0 ? void 0 : instance.primaryColor,
                } },
                React.createElement(Icon, { icon: icon, style: { color: '#fff', width: 20, height: 20, fontSize: 20 } }))) : null,
            React.createElement("div", { className: "oflow-client--rectangle-node--title" },
                ' ',
                React.createElement(Ellipsis, null, label)),
            statusIcon ? (React.createElement(Icon, { icon: statusIcon, style: { color: '#fff', width: 12, height: 12, fontSize: 12 } })) : null)));
}
//# sourceMappingURL=index.js.map